module.exports = __webpack_public_path__ + "static/media/4.790cd459.jpg";